import React from 'react';
import { CheckSquare } from 'lucide-react';

export function TasksWidget() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Tasks</h3>
        <CheckSquare className="h-5 w-5 text-gray-500" />
      </div>
      <div className="space-y-2">
        <p className="text-sm text-gray-500 dark:text-gray-400">No tasks for today</p>
      </div>
    </div>
  );
} 